import { authHeader } from '../../_helpers';
import axios from 'axios';

export const headerPermissionService = {
    headerPermissionData,
}

axios.defaults.headers.common = authHeader();
let token = localStorage.getItem('access_token')


function headerPermissionData(data) {
    return axios.post(`/analytics/user/permissions/?access_token=${token}`,data)
        .then(response => {
            return response;
        });
}


// WEBPACK FOOTER //
// ./src/_services/Analyze/headerPermission.service.js